import { filter as _filter, sortBy as _sortBy, forEach as _forEach } from "lodash";

import StringUtil from "../../../src/app/core/util/StringUtil";
import ReferenceData from "../constants/ReferenceData";
import { getBaseApiUrl } from "../services/authenticationService";
import { executeGet } from "../utils/apiUtils";
import { isLocalhost, hasMocks, localMocksTrue } from "../utils/urlUtils";

import LogService from "./logService";

let activeGroupAccount = {
    individualId: null,
    groupId: null
};

let primaryPlan = {
    database: "",
    planId: "",
    individualId: "",
    groupId: "",
    totalBal: 0,
    accountsDetailsLoaded: false
};

let pending = false;

export function getPrimaryGrpAcct() {
    if (pending || primaryPlan.accountsDetailsLoaded) {
        return Promise.resolve(primaryPlan);
    }
    pending = true;

    const getPrimaryGrpAcctResult = (response) => {
        if (response && response.data) {
            const plan = response.data;
            if (plan.indId && plan.gaId) {
                primaryPlan = {
                    individualId: plan.indId,
                    groupId: plan.gaId,
                    planId: plan.planId,
                    database: plan.database,
                    totalBal: plan.totalBal,
                    accountsDetailsLoaded: true
                };
            }
        }
        pending = false;
        return primaryPlan;
    };

    const liveUrl = __baseApiUrl__ + ReferenceData.PRIMARY_PLAN_URL;
    const mock = window.location.origin + window.location.pathname + "data/get-primary-plan.json";
    const updatedUrl = localMocksTrue ? mock : liveUrl;
    const url = updatedUrl;

    return executeGet(url, "getPrimaryGrpAcctFault")
        .then(getPrimaryGrpAcctResult)
        .catch((e) => {
            LogService.getLogger().error("Error - getPrimaryGrpAcct failed", e);
        });
}

// this set is actually a get; replace with function getPrimaryGrpAcct
// export const setPrimaryGrpAcct

/**
 *  Get account details
 * @param {} groupAccount
 */
export const getAccountDetailsSvc = (groupAccount) => {
    const getAccountDetailsResult = (response) => {
        if (response) {
            activeGroupAccount.groupId = response.data.groupId;
            activeGroupAccount.individualId = response.data.individualId;
            return response.data;
        }
    };

    const mock =
        window.location.origin + window.location.pathname + "data/get-account-details.json";

    const liveUrl =
        __baseApiUrl__ +
        StringUtil.supplant(ReferenceData.ACCOUNT_DETAILS_URL, {
            individualId: groupAccount.individualId,
            groupId: groupAccount.groupId
        });
    const url = isLocalhost() && hasMocks() ? mock : liveUrl;

    return executeGet(url, "getAccountDetailsFault")
        .then(getAccountDetailsResult)
        .catch((e) => {
            console.log("Error - getAccountDetails", e);
        });
};

/**
 *
 * @param {*} groupAccount
 * @param {*} baseApiUrl
 */
export const setActiveGroupAccount = (groupAccount) => {
    if (groupAccount.groupId) {
        activeGroupAccount = groupAccount;
        // next line stays commented out
        // service.setAccountHash(account);
        return Promise.resolve(activeGroupAccount);
    } else {
        // Default account if there is no account hash URL param
        getPrimaryGrpAcct().then(function (result) {
            activeGroupAccount.groupId = result.groupId;
            activeGroupAccount.individualId = result.individualId;
            return activeGroupAccount;
        });
    }
};

export const getAccountSummarySvc = (accountOpenInProgress) => {
    const getAccountSummaryAllResult = (response) => {
        if (response) {
            return response.data;
        } else {
            return null;
        }
    };

    const summaryUrl = accountOpenInProgress
        ? ReferenceData.ACCOUNT_SUMMARY_REFRESH
        : ReferenceData.ACCOUNT_SUMMARY_URL;
    const liveUrl = __baseApiUrl__ + summaryUrl;
    const mock =
        window.location.origin + window.location.pathname + "data/get-account-summary.json";
    const updatedUrl = localMocksTrue ? mock : liveUrl;

    return executeGet(updatedUrl, "getAccountSummarySvcFault")
        .then(getAccountSummaryAllResult)
        .catch((err) => {
            console.log("Error - getAccountSummarySvc", err);
            throw err;
        });
};

export const getBankAccountsList = (params) => {
    const usageType = params.usageType ? params.usageType : "ACHOUT";
    const url =
        __baseApiUrl__ +
        StringUtil.supplant(ReferenceData.BANK_ACCOUNTS_URL, {
            groupId: params.groupId,
            individualId: params.individualId,
            usageType
        });

    const getBankAccountsListSuccess = (res) => {
        return res.data;
    };

    return executeGet(url, "getBankAccountsListFault")
        .then(getBankAccountsListSuccess)
        .catch((err) => {
            console.log("Error - getAccountSummarySvc", err);
            throw err;
        });
};

export const getPrimaryPlanByIndIdSvc = (params) => {
    const getPrimaryPlanByIndIdSuccess = (response) => {
        if (response) {
            return response.data;
        } else {
            return null;
        }
    };

    const mock =
        window.location.origin + window.location.pathname + "data/get-primaryplan-by-indid.json";
    const liveUrl =
        __baseApiUrl__ +
        StringUtil.supplant(ReferenceData.PRIMARY_PLAN_BY_IND_ID, {
            individualId: params.individualId,
            dbName: params.dbName,
            accuCode: params.accuCode
        });
    const updatedUrl = localMocksTrue ? mock : liveUrl;

    return executeGet(updatedUrl, "getPrimaryPlanByIndIdFault")
        .then(getPrimaryPlanByIndIdSuccess)
        .catch((err) => {
            console.log("Error - getPrimaryPlanByIndIdSvc", err);
            throw err;
        });
};

export const updateDefaultPlanSvc = (params) => {
    const updateDefaultPlanSuccess = (response) => {
        if (response && response.data) {
            return response.data.data;
        } else {
            return null;
        }
    };

    const url = StringUtil.supplant(ReferenceData.UPDATE_DEFAULT_PLAN, {
        individualId: params.individualId,
        dbName: params.dbName,
        accuCode: params.accuCode,
        updateDefault: params.updateDefault,
        gaId: params.gaId
    });

    const updatedUrl = __baseApiUrl__ + url;

    return executeGet(updatedUrl, "updateDefaultPlanFault")
        .then(updateDefaultPlanSuccess)
        .catch((err) => {
            console.log("Error - updateDefaultPlanSvc", err);
            throw err;
        });
};

export const updateEngDefaultPlan = (param) => {
    const updateEngDefaultPlanSuccess = (response) => {
        if (response) {
            return response.data;
        } else {
            return null;
        }
    };

    const url =
        getBaseApiUrl() +
        StringUtil.supplant(ReferenceData.UPDATE_DEFAULT_PLAN, {
            individualId: param.individualId,
            dbName: param.dbName,
            accuCode: param.accuCode,
            updateDefault: param.updateDefault,
            gaId: param.gaId
        });

    return executeGet(url, "updateEngDefaultPlanFault")
        .then(updateEngDefaultPlanSuccess)
        .catch((err) => {
            console.log("Error - updateEngDefaultPlanSvc", err);
            throw err;
        });
};

export const refreshNewAcctContext = () => {
    const refreshNewAcctContextSuccess = (response) => {
        if (response && response.data) {
            return response.data;
        } else {
            return null;
        }
    };

    const updatedUrl = __baseApiUrl__ + ReferenceData.UPDATE_NEW_ACCT_CONTEXT;

    return executeGet(updatedUrl, "refreshNewAcctContextFault")
        .then(refreshNewAcctContextSuccess)
        .catch((err) => {
            console.log("Error - refreshNewAcctContext", err);
            throw err;
        });
};

// Provider's Phone and Number
export const getProviderUrlAndPhoneNumber = (individualId, groupId) => {
    const getProviderUrlAndPhoneNumberObjectSuccess = (response) => {
        if (response) {
            return response.data;
        } else {
            return null;
        }
    };

    const url =
        __baseApiUrl__ +
        StringUtil.supplant(ReferenceData.PROVIDER_URL_AND_PHONE_NUMBER_API, {
            individualId,
            groupId
        });

    return executeGet(url, "getProviderUrlAndPhoneNumberFault")
        .then(getProviderUrlAndPhoneNumberObjectSuccess)
        .catch((err) => {
            console.log("Error - getProviderUrlAndPhoneNumberFault", err);
            throw err;
        });
};

export const getAccountDetailsSummarySvc = (params) => {
    const getAccountSummaryAllResult = (response) => {
        if (response) {
            console.log("getAccountSummaryAllResult :>> ", { response });
            return response.data;
        } else {
            return null;
        }
    };
    const summaryApi = __baseApiUrl__ + ReferenceData.ACCOUNT_DETAILS_SUMMARY_URL;

    const mock =
        window.location.origin + window.location.pathname + "data/get-account-menu-details.json";
    const liveUrl = StringUtil.supplant(summaryApi, params);
    const updatedUrl = localMocksTrue ? mock : liveUrl;

    return executeGet(updatedUrl, "getAccountDetailsSummarySvcFault", params)
        .then(getAccountSummaryAllResult)
        .catch((err) => {
            console.log("Error - getAccountDetailsSummarySvc", err);
            throw err;
        });
};

export const sortPlans = function (allAccounts) {
    let currentContextPlans = [];
    const otherContextPlans = [];
    const nmrowList = {};

    let combinedPlanList = [];
    if (allAccounts.length > 1) {
        // sort plans by gaId for current context
        const inContextListInit = _filter(allAccounts, (item) => {
            return item.currentContext;
        });
        currentContextPlans = _sortBy(inContextListInit, (o) => o.groupId);

        // sort by indId and gaId for out of context plans
        const outOfContextListInit = _filter(allAccounts, (item) => {
            return !item.currentContext;
        });
        const outOfContextList = _sortBy(outOfContextListInit, (o) => o.individualId);

        _forEach(outOfContextList, function (nmplan) {
            const key = nmplan.individualId + "-" + nmplan.accuCode;

            if (nmrowList[key] === undefined || nmrowList[key] === null) {
                nmplan.showToolTip = String(nmplan.name).length > 18;

                nmrowList[key] = [];
                nmrowList[key].push(nmplan);
            } else {
                nmplan.showToolTip = String(nmplan.name).length > 18;

                nmrowList[key].push(nmplan);
            }
        });

        Object.keys(nmrowList).forEach(function (key) {
            if (nmrowList[key].length > 1) {
                const sortedOtherContextPlans = _sortBy(nmrowList[key], (o) => o.groupId);
                _forEach(sortedOtherContextPlans, function (plan) {
                    otherContextPlans.push(plan);
                });
            } else if (nmrowList[key].length == 1) {
                otherContextPlans.push(nmrowList[key][0]);
            }
        }, nmrowList);

        _forEach(currentContextPlans, function (plan) {
            combinedPlanList.push(plan);
        });
        _forEach(otherContextPlans, function (plan) {
            combinedPlanList.push(plan);
        });
    } else {
        combinedPlanList = allAccounts;
    }
    return combinedPlanList;
};

function delayedWindowReload(time = 100) {
    setTimeout(function () {
        window.location.reload(true);
    }, time);
}

export const switchRedirect = function (nextgenDest) {
    const locationPriorToRedirect = window.location.href;
    const currentDomain = window.location.protocol + "://" + window.location.host;
    const redirectDest = currentDomain + nextgenDest;
    if (
        window.location.href === redirectDest ||
        locationPriorToRedirect.indexOf("plan-balances") >= 0 ||
        locationPriorToRedirect.indexOf("other-assets") >= 0
    ) {
        delayedWindowReload(100);
    } else if (
        locationPriorToRedirect.indexOf("enroll") >= 0 &&
        redirectDest.indexOf("enroll") >= 0
    ) {
        window.location.href = redirectDest;
        delayedWindowReload(100);
    } else if (redirectDest.indexOf("account-details") >= 0) {
        window.location.href = redirectDest;
        delayedWindowReload(100);
    } else {
        console.error("Updating window.location - {0}", [redirectDest]);
        window.location.href = redirectDest;
        if (
            locationPriorToRedirect.indexOf("accounts") >= 0 &&
            redirectDest.indexOf("overview") >= 0
        ) {
            delayedWindowReload(100);
        }
    }
};
